import { init as initSlideshow } from './slideshow';
import { init as initlpSwiper } from './lp-slider';
import { init as initNostoTabs } from './nosto-tabs';
import { init as initLpTestimonials } from './lp-testimonials';
import { init as initLpCarousel } from './lp-carousel';
import { init as initLpCarouselSwatch } from './lp-carousel-swatch';
import { init as initLpQuotes } from './lp-quotes';
import { init as initLpStorySlider } from './lp-story-slider';
import { init as initHide } from './hide-oos';
const logErrors = function(err) {
    console.error(err);
};
initHide().catch(logErrors);
initSlideshow().catch(logErrors);
initlpSwiper().catch(logErrors);
initNostoTabs().catch(logErrors);
initLpTestimonials().catch(logErrors);
initLpCarousel().catch(logErrors);
initLpCarouselSwatch().catch(logErrors);
initLpQuotes().catch(logErrors);
initLpStorySlider().catch(logErrors);
